module.exports = __webpack_public_path__ + "media/images/views/tech_client/benefit-1-24f1cf96815d75440f7725cdf05a7912.png";